/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type AccountNav_viewer$ref = any;
type CartNav_viewer$ref = any;
type Likes_viewer$ref = any;
type Notifications_initialViewer$ref = any;
type Notifications_viewer$ref = any;
type SearchBar_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type TopBar_viewer$ref: FragmentReference;
export type TopBar_viewer = {|
  +isNotificationsEnabled: ?boolean,
  +isFavoritesEnabled: ?boolean,
  +isCartEnabled: ?boolean,
  +$fragmentRefs: AccountNav_viewer$ref & CartNav_viewer$ref & Likes_viewer$ref & Notifications_viewer$ref & Notifications_initialViewer$ref & SearchBar_viewer$ref,
  +$refType: TopBar_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "TopBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isNotificationsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "NOTIFICATIONS",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"NOTIFICATIONS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isFavoritesEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "FAVORITES",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isCartEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CART",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"CART\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Likes_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_initialViewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SearchBar_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'bffd7bef184744d7259db44e9d3e4c3c';
module.exports = node;
